import React from 'react';
import ImageSelector from '../components/ImageSelector';
import NodeEditorAction from '../components/NodeEditorAction';
import { PanoramaVFTSceneConfig } from '../models/PanoramaVFTConfig';

type PanoramaVFTSceneEditorProps = {
    scene: PanoramaVFTSceneConfig,
    nodeKey: number,
    updateScene: (s: PanoramaVFTSceneConfig, key: number) => void,
    onChevronUp: (key: number) => void,
    onChevronDown: (key: number) => void,
    onDelete: (key: number) => void,
};

const PanoramaVFTSceneEditor = ({
    scene,
    nodeKey,
    updateScene,
    onChevronUp,
    onChevronDown,
    onDelete }: PanoramaVFTSceneEditorProps) => {

    const labelClasses = "block text-left tracking-wide text-gray-700 text-xs font-bold mb-2";
    const inputClasses = "appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500";

    const onSceneChange = (e: React.FormEvent<HTMLInputElement>) => {
        scene.eventName = e.currentTarget.value;
        updateScene(scene, nodeKey);
    }

    const onImageChange = (src: string) => {
        scene.sourceAsset = src;
        updateScene(scene, nodeKey);
    }

    return (
        <div className='mb-3 border rounded-lg shadow'>
            <div className="px-2 my-2 flex flex-wrap">
                <div className="flex-1 px-3">
                    <div className='mb-4'>
                        <label className={labelClasses}>Unique ID</label>
                        <input 
                            className={inputClasses} 
                            value={scene.eventName} 
                            onChange={onSceneChange}
                            placeholder='Enter the Unique ID of the scene' />
                    </div>
                    <div className='mb-4'>
                        <label className={labelClasses}>Panorama image</label>
                        <ImageSelector value={scene.sourceAsset} onImageChange={onImageChange} />
                    </div>
                </div>

                <NodeEditorAction nodeKey={nodeKey} onChevronUp={onChevronUp} onChevronDown={onChevronDown} onDelete={onDelete} />
            </div>
        </div>
    )
}

export default PanoramaVFTSceneEditor;

